export const zapierLogoConfig = {
    name: 'ZapierLogo',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/3127b311f8bd7d4c4a59753ec19143a1.png',
    inputs: [
        {
            name: 'height',
            type: 'number',
        },
        {
            name: 'variant',
            type: 'string',
            enum: [
                'wordmark',
                'symbol',
                'wordmark-horizontal',
                'wordmark-horizontal-inverse',
            ],
        },
        {
            name: 'width',
            type: 'number',
        },
    ],
};
//# sourceMappingURL=config.js.map